// extracted by mini-css-extract-plugin
export default {"Content":"index__Content--EaW58","content":"index__Content--EaW58"};